document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.querySelector('[data-kerlux-modal-overlay]');
  if (!overlay) return;

  var titleEl = overlay.querySelector('[data-kerlux-modal-title]');
  var decorInput = overlay.querySelector('[data-kerlux-decor-input]');

  document.querySelectorAll('[data-kerlux-notify]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var decor = btn.getAttribute('data-decor');
      titleEl.textContent = 'Upozornit na dostupnost ' + decor;
      if (decorInput) decorInput.value = decor;
      overlay.classList.add('is-open');
    });
  });

  overlay.querySelectorAll('[data-kerlux-modal-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { overlay.classList.remove('is-open'); });
  });

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) overlay.classList.remove('is-open');
  });

  if (window.location.hash === '#ContactForm-kerlux' || overlay.querySelector('[data-kerlux-modal-confirm]')) {
    overlay.classList.add('is-open');
  }
});
